module.exports = __webpack_public_path__ + "static/img/success8.26596d37.png";